import { Pipe, PipeTransform } from '@angular/core';
import { Candidate } from '../models/candidate.model';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {

  transform(candidate: Candidate, ...args: unknown[]): string {
    // corregido para ESFBITE-1342 por pentest para evitar XSS
    const name = (candidate.name || '').replace(/[<>"'&]/g, '');
    const surname = (candidate.surnameComplete || '').replace(/[<>"'&]/g, '');
    return (name + ' ' + surname).trim()
      .split(/\s/).reduce((a, b) => a += b.slice(0, 1).toUpperCase() + '.', '');
  }

}
